export default {
      id: "home-usage",
      viewBox: "0 0 20 17",
      url: "assets/" + "sprite.svg#home-usage",
      toString: function () {
        return this.url;
      }
    }